import React from "react";
import "./videoSection.scss";
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";

const VideoSection = () => {
  return (
    <section id="videoSection">
      <Wrapper>
        <div className="videoSection">
          <CommonHeader
            title="Know More"
            subtitle="My Intro Video"
            bgText="Videos"
            center={true}
          />

          <div className="videoSection_video">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/8ibOheFrUiI"
              title="Nur Alam Intro Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default VideoSection;
